var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h2', [_vm._v("Source Code")]), _c('prism-editor', {
    attrs: {
      "line-numbers": ""
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('h2', {
    staticClass: "mt-4 d-flex align-center"
  }, [_c('span', [_vm._v("Replaced")]), _c('span', [_c('v-radio-group', {
    attrs: {
      "inline": "",
      "hide-details": ""
    },
    model: {
      value: _vm.type,
      callback: function ($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Line",
      "value": "line"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Array",
      "value": "array"
    }
  })], 1)], 1)]), _c('v-sheet', {
    attrs: {
      "border": "",
      "width": "100%",
      "height": "500"
    }
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "length": "50"
    },
    domProps: {
      "value": _vm.replaced
    }
  })])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }